declare let dataLayer: Array<any>;

export const buildLoginfromCheckoutEvent = () => {
  dataLayer.push({
    event: 'login_from_checkout'
  });
};